import React, { useEffect, useRef } from 'react';
const uniqueWindowName = `window_${Date.now()}`;

function HtmlInNewWindow({ htmlContent }) {
  const newWindowRef = useRef(null); // Use a ref to track the new window

  useEffect(() => {
    if (htmlContent) {
      // Close the previous window if it exists
      if (newWindowRef.current && !newWindowRef.current.closed) {
        newWindowRef.current.close();
      }

      // Open a new browser window
      newWindowRef.current = window.open('', '_blank', 'width=800,height=600');
      //newWindowRef.current = window.open('', uniqueWindowName, 'width=800,height=600');
      if (newWindowRef.current) {
        // Write the HTML content to the new window
        newWindowRef.current.document.open();
        newWindowRef.current.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Response HTML</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  line-height: 1.6;
                  padding: 20px;
                }
              </style>
            </head>
            <body>
              ${htmlContent}
            </body>
          </html>
        `);
        newWindowRef.current.document.close();
      } else {
        alert('Unable to open a new browser window. Please check your browser settings or disable pop-up blockers.');
      }
    }

    // Cleanup function to close the window when the component unmounts
    return () => {
      if (newWindowRef.current && !newWindowRef.current.closed) {
        newWindowRef.current.close();
      }
    };
  },); // Trigger the effect whenever htmlContent changes

  return null; // This component doesn't render anything in the current window
}

export default HtmlInNewWindow;